import React, { Component } from 'react';
import { ActElementTd } from './ActElementTd';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';

export class ActElementTr extends Component {
	render() {
		const {
			childrens,
			showComment,
			canCommentAndSetOpinion,
			showOpinion = false,
			isCommentAdding = false
		} = this.props;

		return (
			<tr>
				{map(
					orderBy(childrens, (c) => c.order),
					(child) =>
						child.name === 'komorka' ? (
							<ActElementTd
								showComment={showComment}
								saveComment={(comment) => this.props.saveComment(comment)}
								canCommentAndSetOpinion={canCommentAndSetOpinion}
								showOpinion={showOpinion}
								isCommentAdding={isCommentAdding}
								{...child}
							/>
						) : (
							<div />
						)
				)}
			</tr>
		);
	}
}
